// extracted by extract-css-chunks-webpack-plugin
module.exports = {"link":"banner__link--2j0oD","image":"banner__image--1sJ48"};